import { render, staticRenderFns } from "./machineryManagement.vue?vue&type=template&id=520e0e4a&scoped=true&"
import script from "./machineryManagement.vue?vue&type=script&lang=js&"
export * from "./machineryManagement.vue?vue&type=script&lang=js&"
import style0 from "./machineryManagement.vue?vue&type=style&index=0&id=520e0e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e0e4a",
  null
  
)

export default component.exports